import {Component, OnInit} from '@angular/core';
import {EmpresaService} from "../../services/empresa.service";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {RotaGuardClient} from "../../guards/auth-loja.guard";

@Component({
  selector: 'app-conta-mcpay',
  templateUrl: './conta-mcpay.component.html',
  styleUrls: ['./conta-mcpay.component.scss']
})
export class ContaMcpayComponent implements OnInit {
  carregando = false;
  executandoAcao = '';
  detalhesContaCellcoin: any;
  erro: string;
  mensagem: string;
  aba = 'visao';
  isAdmin = false;
  podeVisualizarConta = false;
  modalConfirmacaoContaCellcoin: any = null;
  carregandoChargebacksCellcoin = false;
  chargebacksConsultadosCellcoin = false;
  chargebacksCellcoin: Array<any> = [];
  erroChargebacksCellcoin = '';
  mensagemChargebacksCellcoin = '';
  importandoChargebackCellcoin: any = null;
  carregandoExtratoCellcoin = false;
  erroExtratoCellcoin = '';
  extratoCellcoin: any = null;
  movimentosExtratoCellcoin: Array<any> = [];
  paginaExtratoCellcoin = 1;
  totalPaginasExtratoCellcoin = 0;
  totalItensExtratoCellcoin = 0;
  dataInicialExtratoCellcoin = '';
  dataFinalExtratoCellcoin = '';
  tipoMovimentoExtratoCellcoin = '';
  carregandoConsolidadoCellcoin = false;
  erroConsolidadoCellcoin = '';
  consolidadoCellcoin: any = null;
  saldosConsolidadosCellcoin: Array<any> = [];
  dataInicialConsolidadoCellcoin = '';
  dataFinalConsolidadoCellcoin = '';
  carregandoRecebiveisCellcoin = false;
  erroRecebiveisCellcoin = '';
  relatorioRecebiveisCellcoin: any = null;
  recebiveisCellcoin: Array<any> = [];
  solicitacoesRecebiveisCellcoin: Array<any> = [];
  solicitacoesRecebiveisCarregadasCellcoin = false;
  requestIdRecebiveisSelecionadoCellcoin = '';
  dataInicialRecebiveisCellcoin = '';
  dataFinalRecebiveisCellcoin = '';
  statusRecebiveisCellcoin = 'pending';
  carregandoClientesCellcoin = false;
  clientesConsultadosCellcoin = false;
  erroClientesCellcoin = '';
  clientesCellcoin: Array<any> = [];
  paginaClientesCellcoin = 1;
  totalPaginasClientesCellcoin = 0;
  totalClientesCellcoin = 0;
  possuiProximaPaginaClientesCellcoin = false;
  tipoCobrancaCellcoin = '';
  carregandoCobrancasCellcoin = false;
  erroCobrancasCellcoin = '';
  cobrancasPixCellcoin: Array<any> = [];
  cobrancasCartaoCellcoin: Array<any> = [];
  retornoCobrancasPixCellcoin: any = null;
  retornoCobrancasCartaoCellcoin: any = null;
  paginaCobrancasPixCellcoin = 1;
  totalPaginasCobrancasPixCellcoin = 0;
  paginaCobrancasCartaoCellcoin = 1;
  totalPaginasCobrancasCartaoCellcoin = 0;
  possuiProximaPaginaCobrancasCartaoCellcoin = false;
  dataInicialCobrancasCellcoin = '';
  dataFinalCobrancasCellcoin = '';
  modalWebhooksContaCellcoin = false;
  carregandoOpcoesWebhooksContaCellcoin = false;
  carregandoWebhooksContaCellcoin = false;
  opcoesWebhooksContaCellcoin: Array<any> = [];
  webhookContaSelecionado = '';
  replayWebhooksContaCellcoin: any = null;
  erroWebhooksContaCellcoin = '';
  mensagemWebhooksContaCellcoin = '';
  reenviandoWebhookContaCellcoin = '';
  tiposMovimentoExtratoCellcoin = [
    {valor: '', rotulo: 'Todas as movimentações'},
    {valor: 'PIXPAYMENTIN', rotulo: 'Pix recebido'},
    {valor: 'PIXPAYMENTOUT', rotulo: 'Pix enviado'},
    {valor: 'PIXREVERSALIN', rotulo: 'Estorno Pix recebido'},
    {valor: 'PIXREVERSALOUT', rotulo: 'Estorno Pix enviado'},
    {valor: 'TEFTRANSFERIN', rotulo: 'Transferência recebida'},
    {valor: 'TEFTRANSFEROUT', rotulo: 'Transferência enviada'},
    {valor: 'TEDTRANSFERIN', rotulo: 'TED recebida'},
    {valor: 'TEDTRANSFEROUT', rotulo: 'TED enviada'},
    {valor: 'TEDREVERSALIN', rotulo: 'Estorno de TED recebido'},
    {valor: 'TEDREVERSALOUT', rotulo: 'Estorno de TED enviado'},
    {valor: 'CHARGEIN', rotulo: 'Cobrança recebida'},
    {valor: 'ENTRYCREDIT', rotulo: 'Crédito em conta'},
    {valor: 'ENTRYDEBIT', rotulo: 'Débito em conta'},
    {valor: 'BILLPAYMENT', rotulo: 'Pagamento de conta'},
    {valor: 'BILLPAYMENTCHARGEBACK', rotulo: 'Estorno de pagamento de conta'},
    {valor: 'RECHARGE', rotulo: 'Recarga'},
    {valor: 'RECHARGECHARGEBACK', rotulo: 'Estorno de recarga'},
    {valor: 'JUDICIALMOVEMENTIN', rotulo: 'Movimentação judicial recebida'},
    {valor: 'JUDICIALMOVEMENTOUT', rotulo: 'Movimentação judicial enviada'},
    {valor: 'SLC', rotulo: 'Liquidação de cartão'}
  ];

  constructor(private empresaService: EmpresaService,
              private autorizacaoService: AutorizacaoService) { }

  ngOnInit(): void {
    const usuario = this.autorizacaoService.getUser();
    this.isAdmin = !!(usuario && usuario.superadmin);
    this.podeVisualizarConta = RotaGuardClient.visualizarContaCellcoin(usuario);

    if(!this.podeVisualizarConta){
      this.erro = 'Você não tem permissão para visualizar a conta Cellcoin.';
      return;
    }

    this.inicializePeriodoExtratoCellcoin();
    this.carregueDetalhes();
  }

  selecioneAba(aba: string) {
    this.aba = aba;

    if(aba === 'extrato' && !this.extratoCellcoin && !this.carregandoExtratoCellcoin)
      this.carregueExtratoCellcoin(1);

    if(aba === 'consolidado' && !this.consolidadoCellcoin && !this.carregandoConsolidadoCellcoin)
      this.carregueConsolidadoCellcoin();

    if(aba === 'recebiveis' && !this.solicitacoesRecebiveisCarregadasCellcoin &&
      !this.carregandoRecebiveisCellcoin)
      this.carregueSolicitacoesRecebiveisCellcoin();

    if(aba === 'clientes' && !this.clientesConsultadosCellcoin && !this.carregandoClientesCellcoin)
      this.carregueClientesCellcoin(1);

    if(aba === 'cobrancas'){
      this.ajusteTipoCobrancaCellcoin();

      if(this.tipoCobrancaCellcoin && !this.possuiRetornoCobrancaCellcoin() && !this.carregandoCobrancasCellcoin)
        this.carregueCobrancasCellcoin();
    }

    if(aba === 'chargebacks' && !this.chargebacksConsultadosCellcoin && !this.carregandoChargebacksCellcoin)
      this.carregueChargebacksCellcoin();
  }

  carregueExtratoCellcoin(pagina: number = 1) {
    if(this.carregandoExtratoCellcoin) return;

    const erroPeriodo = this.validePeriodoExtratoCellcoin();
    if(erroPeriodo){
      this.erroExtratoCellcoin = erroPeriodo;
      return;
    }

    this.carregandoExtratoCellcoin = true;
    this.erroExtratoCellcoin = '';
    this.empresaService.obtenhaExtratoContaCellcoin({
      dateFrom: this.dataInicialExtratoCellcoin,
      dateTo: this.dataFinalExtratoCellcoin,
      movementType: this.tipoMovimentoExtratoCellcoin,
      page: pagina
    }).then((extrato: any) => {
      this.extratoCellcoin = extrato;
      this.movimentosExtratoCellcoin = extrato?.movements || [];
      this.paginaExtratoCellcoin = Number(extrato?.currentPage || pagina);
      this.totalPaginasExtratoCellcoin = Number(extrato?.totalPages || 0);
      this.totalItensExtratoCellcoin = Number(extrato?.totalItems || this.movimentosExtratoCellcoin.length);
      this.carregandoExtratoCellcoin = false;
    }).catch((erro: any) => {
      this.erroExtratoCellcoin = this.extraiaMensagemErro(erro);
      this.carregandoExtratoCellcoin = false;
    });
  }

  paginaAnteriorExtratoCellcoin() {
    if(this.paginaExtratoCellcoin > 1)
      this.carregueExtratoCellcoin(this.paginaExtratoCellcoin - 1);
  }

  proximaPaginaExtratoCellcoin() {
    if(this.paginaExtratoCellcoin < this.totalPaginasExtratoCellcoin)
      this.carregueExtratoCellcoin(this.paginaExtratoCellcoin + 1);
  }

  rotuloTipoMovimentoCellcoin(tipo: string) {
    const opcao = this.tiposMovimentoExtratoCellcoin.find((item: any) => item.valor === tipo);
    return opcao?.rotulo || tipo || 'Movimentação';
  }

  movimentoEhCreditoCellcoin(movimento: any) {
    const balanceType = String(movimento?.balanceType || '').toUpperCase();
    if(balanceType) return balanceType === 'CREDIT';

    const movementType = String(movimento?.movementType || '').toUpperCase();
    return movementType.endsWith('IN') || ['CHARGEIN', 'ENTRYCREDIT', 'SLC'].indexOf(movementType) >= 0;
  }

  identificadorMovimentoCellcoin(movimento: any) {
    const adicional = movimento?.additionalInformation || {};
    return movimento?.clientCode || adicional.clientCode || adicional.endToEndId ||
      movimento?.endToEndId || movimento?.id || '-';
  }

  saldoMovimentoCellcoin(movimento: any) {
    const adicional = movimento?.additionalInformation || {};
    const saldo = movimento?.currentBalance != null ? movimento.currentBalance : adicional.currentBalance;
    return saldo == null ? null : Number(saldo);
  }

  valorMovimentoCellcoin(movimento: any) {
    return Math.abs(Number(movimento?.amount || 0));
  }

  formateDataMovimentoCellcoin(valor: any) {
    return this.formateDataHoraCellcoin(valor);
  }

  carregueConsolidadoCellcoin() {
    if(this.carregandoConsolidadoCellcoin) return;

    const erroPeriodo = this.validePeriodoCellcoin(
      this.dataInicialConsolidadoCellcoin,
      this.dataFinalConsolidadoCellcoin,
      'consolidado'
    );
    if(erroPeriodo){
      this.erroConsolidadoCellcoin = erroPeriodo;
      return;
    }

    this.carregandoConsolidadoCellcoin = true;
    this.erroConsolidadoCellcoin = '';
    this.empresaService.obtenhaConsolidadoContaCellcoin({
      dateFrom: this.dataInicialConsolidadoCellcoin,
      dateTo: this.dataFinalConsolidadoCellcoin
    }).then((consolidado: any) => {
      this.consolidadoCellcoin = consolidado;
      this.saldosConsolidadosCellcoin = consolidado?.balances || [];
      this.carregandoConsolidadoCellcoin = false;
    }).catch((erro: any) => {
      this.erroConsolidadoCellcoin = this.extraiaMensagemErro(erro);
      this.carregandoConsolidadoCellcoin = false;
    });
  }

  saldoAtualConsolidadoCellcoin() {
    return Number(this.consolidadoCellcoin?.currentBalance || 0);
  }

  totalCreditosConsolidadoCellcoin() {
    return this.saldosConsolidadosCellcoin.reduce(
      (total: number, saldo: any) => total + Math.abs(Number(saldo?.totalMovementCredit || 0)),
      0
    );
  }

  totalDebitosConsolidadoCellcoin() {
    return this.saldosConsolidadosCellcoin.reduce(
      (total: number, saldo: any) => total + Math.abs(Number(saldo?.totalMovementDebit || 0)),
      0
    );
  }

  resultadoConsolidadoCellcoin() {
    return this.saldosConsolidadosCellcoin.reduce(
      (total: number, saldo: any) => total + Number(saldo?.totalMovement || 0),
      0
    );
  }

  saldoInicialDiaConsolidadoCellcoin(saldo: any) {
    return Number(saldo?.balance || 0) - Number(saldo?.totalMovement || 0);
  }

  saldoFinalDiaConsolidadoCellcoin(saldo: any) {
    return Number(saldo?.balance || 0);
  }

  movimentosDiaConsolidadoCellcoin(saldo: any) {
    return Array.isArray(saldo?.movements) ? saldo.movements : [];
  }

  carregueClientesCellcoin(pagina: number = 1) {
    if(this.carregandoClientesCellcoin) return;

    this.carregandoClientesCellcoin = true;
    this.erroClientesCellcoin = '';
    this.empresaService.listeClientesContaCellcoin({page: pagina})
      .then((retorno: any) => {
        this.clientesCellcoin = retorno?.clientes || [];
        this.paginaClientesCellcoin = Number(retorno?.pagination?.page || pagina);
        this.totalPaginasClientesCellcoin = Number(retorno?.pagination?.totalPages || 0);
        this.totalClientesCellcoin = Number(retorno?.pagination?.totalItems || this.clientesCellcoin.length);
        this.possuiProximaPaginaClientesCellcoin = retorno?.pagination?.hasNext === true;
        this.clientesConsultadosCellcoin = true;
        this.carregandoClientesCellcoin = false;
      })
      .catch((erro: any) => {
        this.erroClientesCellcoin = this.extraiaMensagemErro(erro);
        this.carregandoClientesCellcoin = false;
      });
  }

  paginaAnteriorClientesCellcoin() {
    if(this.paginaClientesCellcoin > 1)
      this.carregueClientesCellcoin(this.paginaClientesCellcoin - 1);
  }

  proximaPaginaClientesCellcoin() {
    if(this.possuiProximaPaginaClientesCellcoin)
      this.carregueClientesCellcoin(this.paginaClientesCellcoin + 1);
  }

  emailClienteCellcoin(cliente: any) {
    const emails = cliente?.emails || cliente?.Emails || [];
    const primeiro = Array.isArray(emails) ? emails[0] : emails;
    return primeiro?.email || primeiro?.value || primeiro || cliente?.email || '-';
  }

  telefoneClienteCellcoin(cliente: any) {
    const telefones = cliente?.phones || cliente?.Phones || [];
    const primeiro = Array.isArray(telefones) ? telefones[0] : telefones;
    return primeiro?.phone || primeiro?.number || primeiro?.value || primeiro || cliente?.phone || '-';
  }

  formateDataClienteCellcoin(valor: any) {
    return this.formateDataHoraCellcoin(valor);
  }

  movimentoConsolidadoEhCreditoCellcoin(movimento: any) {
    return String(movimento?.balanceType || '').toUpperCase().indexOf('CREDIT') === 0;
  }

  valorMovimentoConsolidadoCellcoin(movimento: any) {
    return Math.abs(Number(movimento?.totalMovement || 0));
  }

  formateDataConsolidadoCellcoin(valor: string) {
    const partes = String(valor || '').split('-');
    return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : valor || '-';
  }

  soliciteRelatorioRecebiveisCellcoin() {
    if(this.carregandoRecebiveisCellcoin) return;

    const erroPeriodo = this.validePeriodoCellcoin(
      this.dataInicialRecebiveisCellcoin,
      this.dataFinalRecebiveisCellcoin,
      'relatório de recebíveis',
      30
    );
    if(erroPeriodo){
      this.erroRecebiveisCellcoin = erroPeriodo;
      return;
    }

    this.carregandoRecebiveisCellcoin = true;
    this.erroRecebiveisCellcoin = '';
    this.relatorioRecebiveisCellcoin = null;
    this.recebiveisCellcoin = [];
    this.empresaService.soliciteRelatorioRecebiveisContaCellcoin({
      startAt: this.dataInicialRecebiveisCellcoin,
      endAt: this.dataFinalRecebiveisCellcoin,
      status: this.statusRecebiveisCellcoin
    }).then((relatorio: any) => {
      this.relatorioRecebiveisCellcoin = relatorio;
      this.requestIdRecebiveisSelecionadoCellcoin = relatorio?.requestId || '';
      this.solicitacoesRecebiveisCellcoin = [
        relatorio,
        ...this.solicitacoesRecebiveisCellcoin.filter((item: any) => item.requestId !== relatorio?.requestId)
      ];
      this.carregandoRecebiveisCellcoin = false;
    }).catch((erro: any) => {
      this.erroRecebiveisCellcoin = this.extraiaMensagemErro(erro);
      this.carregandoRecebiveisCellcoin = false;
    });
  }

  consulteRelatorioRecebiveisCellcoin() {
    const requestId = this.requestIdRecebiveisSelecionadoCellcoin ||
      this.relatorioRecebiveisCellcoin?.requestId;
    if(!requestId || this.carregandoRecebiveisCellcoin) return;

    this.carregandoRecebiveisCellcoin = true;
    this.erroRecebiveisCellcoin = '';
    this.empresaService.consulteRelatorioRecebiveisContaCellcoin(requestId)
      .then((relatorio: any) => {
        this.relatorioRecebiveisCellcoin = {
          ...this.relatorioRecebiveisCellcoin,
          ...relatorio
        };
        this.atualizeSolicitacaoRecebiveisCellcoin(relatorio);
        this.recebiveisCellcoin = relatorio?.recebiveis || [];
        this.carregandoRecebiveisCellcoin = false;
      })
      .catch((erro: any) => {
        this.erroRecebiveisCellcoin = this.extraiaMensagemErro(erro);
        this.carregandoRecebiveisCellcoin = false;
      });
  }

  carregueSolicitacoesRecebiveisCellcoin() {
    if(this.carregandoRecebiveisCellcoin) return;

    this.carregandoRecebiveisCellcoin = true;
    this.erroRecebiveisCellcoin = '';
    this.empresaService.listeSolicitacoesRelatorioRecebiveisContaCellcoin()
      .then((retorno: any) => {
        this.solicitacoesRecebiveisCellcoin = retorno?.solicitacoes || [];
        this.solicitacoesRecebiveisCarregadasCellcoin = true;
        this.carregandoRecebiveisCellcoin = false;

        if(!this.solicitacoesRecebiveisCellcoin.length){
          this.requestIdRecebiveisSelecionadoCellcoin = '';
          this.relatorioRecebiveisCellcoin = null;
          this.recebiveisCellcoin = [];
          return;
        }

        this.requestIdRecebiveisSelecionadoCellcoin = this.solicitacoesRecebiveisCellcoin[0].requestId;
        this.selecioneSolicitacaoRecebiveisCellcoin();
      })
      .catch((erro: any) => {
        this.erroRecebiveisCellcoin = this.extraiaMensagemErro(erro);
        this.carregandoRecebiveisCellcoin = false;
      });
  }

  selecioneSolicitacaoRecebiveisCellcoin(requestId: string = null) {
    if(requestId != null)
      this.requestIdRecebiveisSelecionadoCellcoin = requestId;

    const solicitacao = this.solicitacoesRecebiveisCellcoin
      .find((item: any) => item.requestId === this.requestIdRecebiveisSelecionadoCellcoin);

    this.relatorioRecebiveisCellcoin = solicitacao || null;
    this.recebiveisCellcoin = [];

    if(solicitacao)
      this.consulteRelatorioRecebiveisCellcoin();
  }

  rotuloSolicitacaoRecebiveisCellcoin(solicitacao: any) {
    const solicitadaEm = this.formateDataHoraCellcoin(solicitacao?.solicitadoEm);
    const periodo = `${this.formateDataConsolidadoCellcoin(solicitacao?.startAt)} a ` +
      `${this.formateDataConsolidadoCellcoin(solicitacao?.endAt)}`;
    return `${solicitadaEm} · ${periodo} · ${solicitacao?.status || 'PROCESSING'}`;
  }

  private atualizeSolicitacaoRecebiveisCellcoin(relatorio: any) {
    const indice = this.solicitacoesRecebiveisCellcoin
      .findIndex((item: any) => item.requestId === relatorio?.requestId);

    if(indice < 0) return;

    this.solicitacoesRecebiveisCellcoin[indice] = {
      ...this.solicitacoesRecebiveisCellcoin[indice],
      ...relatorio
    };
  }

  relatorioRecebiveisConcluidoCellcoin() {
    return String(this.relatorioRecebiveisCellcoin?.status || '').toUpperCase() === 'COMPLETED';
  }

  rotuloStatusRecebivelCellcoin(status: any) {
    const rotulos: any = {
      pending: 'Pendente',
      payed: 'Pago',
      payedPartial: 'Pago parcialmente'
    };
    return rotulos[String(status || '')] || status || '-';
  }

  totalRecebiveisCellcoin(campo: string) {
    return this.recebiveisCellcoin.reduce(
      (total: number, recebivel: any) => total + Number(recebivel?.[campo] || 0),
      0
    );
  }

  totalTaxasRecebivelCellcoin(recebivel: any) {
    return Number(recebivel?.taxMdr || 0) + Number(recebivel?.taxAdvancement || 0);
  }

  selecioneTipoCobrancaCellcoin(tipo: string) {
    if(!this.tipoCobrancaLiberadoCellcoin(tipo)) return;

    this.tipoCobrancaCellcoin = tipo;
    this.erroCobrancasCellcoin = '';

    if(!this.possuiRetornoCobrancaCellcoin())
      this.carregueCobrancasCellcoin();
  }

  carregueCobrancasCellcoin() {
    if(!this.tipoCobrancaLiberadoCellcoin(this.tipoCobrancaCellcoin)) return;

    if(this.tipoCobrancaCellcoin === 'cartao')
      return this.carregueCobrancasCartaoCellcoin();

    return this.carregueCobrancasPixCellcoin(1);
  }

  pixLiberadoCellcoin() {
    return !!this.detalhesContaCellcoin?.pixLiberado;
  }

  cartaoLiberadoCellcoin() {
    return !!this.detalhesContaCellcoin?.cartaoCreditoLiberado;
  }

  private tipoCobrancaLiberadoCellcoin(tipo: string) {
    return tipo === 'pix' ? this.pixLiberadoCellcoin() :
      tipo === 'cartao' && this.cartaoLiberadoCellcoin();
  }

  private possuiRetornoCobrancaCellcoin() {
    return this.tipoCobrancaCellcoin === 'pix' ?
      !!this.retornoCobrancasPixCellcoin :
      !!this.retornoCobrancasCartaoCellcoin;
  }

  private ajusteTipoCobrancaCellcoin() {
    if(this.tipoCobrancaLiberadoCellcoin(this.tipoCobrancaCellcoin)) return;

    this.tipoCobrancaCellcoin = this.pixLiberadoCellcoin() ? 'pix' :
      this.cartaoLiberadoCellcoin() ? 'cartao' : '';
  }

  carregueCobrancasPixCellcoin(pagina: number = 1) {
    if(this.carregandoCobrancasCellcoin) return;

    const erroPeriodo = this.validePeriodoCellcoin(
      this.dataInicialCobrancasCellcoin,
      this.dataFinalCobrancasCellcoin,
      'período das cobranças'
    );
    if(erroPeriodo){
      this.erroCobrancasCellcoin = erroPeriodo;
      return;
    }

    this.carregandoCobrancasCellcoin = true;
    this.erroCobrancasCellcoin = '';
    this.empresaService.listeCobrancasPixContaCellcoin({
      dateFrom: this.dataInicialCobrancasCellcoin,
      dateTo: this.dataFinalCobrancasCellcoin,
      page: pagina
    }).then((retorno: any) => {
      this.retornoCobrancasPixCellcoin = retorno;
      this.cobrancasPixCellcoin = retorno?.cobrancas || [];
      this.paginaCobrancasPixCellcoin = Number(retorno?.pagination?.page || pagina);
      this.totalPaginasCobrancasPixCellcoin = Number(retorno?.pagination?.totalPages || 0);
      this.carregandoCobrancasCellcoin = false;
    }).catch((erro: any) => {
      this.erroCobrancasCellcoin = this.extraiaMensagemErro(erro);
      this.carregandoCobrancasCellcoin = false;
    });
  }

  carregueCobrancasCartaoCellcoin(pagina: number = 1) {
    if(this.carregandoCobrancasCellcoin) return;

    const erroPeriodo = this.validePeriodoCellcoin(
      this.dataInicialCobrancasCellcoin,
      this.dataFinalCobrancasCellcoin,
      'período das cobranças'
    );
    if(erroPeriodo){
      this.erroCobrancasCellcoin = erroPeriodo;
      return;
    }

    this.carregandoCobrancasCellcoin = true;
    this.erroCobrancasCellcoin = '';
    this.empresaService.listeCobrancasCartaoContaCellcoin({
      dateFrom: this.dataInicialCobrancasCellcoin,
      dateTo: this.dataFinalCobrancasCellcoin,
      page: pagina
    }).then((retorno: any) => {
      this.retornoCobrancasCartaoCellcoin = retorno;
      this.cobrancasCartaoCellcoin = retorno?.cobrancas || [];
      this.paginaCobrancasCartaoCellcoin = Number(retorno?.pagination?.page || pagina);
      this.totalPaginasCobrancasCartaoCellcoin = Number(retorno?.pagination?.totalPages || 0);
      this.possuiProximaPaginaCobrancasCartaoCellcoin = retorno?.pagination?.hasNext === true;
      this.carregandoCobrancasCellcoin = false;
    }).catch((erro: any) => {
      this.erroCobrancasCellcoin = this.extraiaMensagemErro(erro);
      this.carregandoCobrancasCellcoin = false;
    });
  }

  paginaAnteriorCobrancasPixCellcoin() {
    if(this.paginaCobrancasPixCellcoin > 1)
      this.carregueCobrancasPixCellcoin(this.paginaCobrancasPixCellcoin - 1);
  }

  proximaPaginaCobrancasPixCellcoin() {
    if(this.paginaCobrancasPixCellcoin < this.totalPaginasCobrancasPixCellcoin)
      this.carregueCobrancasPixCellcoin(this.paginaCobrancasPixCellcoin + 1);
  }

  paginaAnteriorCobrancasCartaoCellcoin() {
    if(this.paginaCobrancasCartaoCellcoin > 1)
      this.carregueCobrancasCartaoCellcoin(this.paginaCobrancasCartaoCellcoin - 1);
  }

  proximaPaginaCobrancasCartaoCellcoin() {
    if(this.possuiProximaPaginaCobrancasCartaoCellcoin)
      this.carregueCobrancasCartaoCellcoin(this.paginaCobrancasCartaoCellcoin + 1);
  }

  transacaoCobrancaCartaoCellcoin(cobranca: any) {
    const transacoes = cobranca?.Transactions || cobranca?.transactions || [];
    return Array.isArray(transacoes) && transacoes.length ? transacoes[0] : {};
  }

  clienteCobrancaCartaoCellcoin(cobranca: any) {
    return cobranca?.Customer || cobranca?.customer || {};
  }

  bandeiraCobrancaCartaoCellcoin(cobranca: any) {
    const transacao = this.transacaoCobrancaCartaoCellcoin(cobranca);
    const cartao = transacao?.CreditCard?.Card || transacao?.creditCard?.card || {};
    return cartao?.Brand?.name || cartao?.brand?.name || '';
  }

  statusCobrancaPixCellcoin(cobranca: any) {
    return cobranca?.pix?.status || cobranca?.status || '-';
  }

  statusCobrancaCartaoCellcoin(cobranca: any) {
    const transacao = this.transacaoCobrancaCartaoCellcoin(cobranca);
    return transacao?.statusDescription || transacao?.status || cobranca?.status || '-';
  }

  formateDataCobrancaCellcoin(valor: any) {
    if(/^\d{4}-\d{2}-\d{2}$/.test(String(valor || '')))
      return this.formateDataConsolidadoCellcoin(valor);

    return this.formateDataMovimentoCellcoin(valor);
  }

  formateCentavosCellcoin(valor: any) {
    return this.formateMoedaCellcoin(Number(valor || 0) / 100);
  }

  carregueDetalhes() {
    if(this.carregando) return;

    this.carregando = true;
    this.erro = '';
    this.empresaService.obtenhaDetalhesContaCellcoin()
      .then((detalhes: any) => {
        this.detalhesContaCellcoin = detalhes;
        this.ajusteTipoCobrancaCellcoin();
        this.carregando = false;
      })
      .catch((erro: any) => {
        this.erro = erro?.message || erro;
        this.carregando = false;
      });
  }

  volteParaFormasPagamento() {
    window.location.assign('/admin/loja/formaspagamento/onlinemci');
  }

  abraWebhooksContaCellcoin() {
    this.modalWebhooksContaCellcoin = true;
    this.erroWebhooksContaCellcoin = '';
    this.mensagemWebhooksContaCellcoin = '';

    if(this.opcoesWebhooksContaCellcoin.length){
      if(!this.webhookContaSelecionado)
        this.webhookContaSelecionado = this.opcoesWebhooksContaCellcoin[0].key;
      this.carregueWebhooksContaCellcoin();
      return;
    }

    this.carregandoOpcoesWebhooksContaCellcoin = true;
    this.empresaService.listeOpcoesReplayWebhooksCellcoin().then((opcoes: any) => {
      this.opcoesWebhooksContaCellcoin = Array.isArray(opcoes) ? opcoes : [];
      this.webhookContaSelecionado = this.opcoesWebhooksContaCellcoin[0]?.key || '';
      this.carregandoOpcoesWebhooksContaCellcoin = false;

      if(this.webhookContaSelecionado)
        this.carregueWebhooksContaCellcoin();
    }).catch((erro: any) => {
      this.carregandoOpcoesWebhooksContaCellcoin = false;
      this.erroWebhooksContaCellcoin = this.extraiaMensagemErro(erro);
    });
  }

  fecheWebhooksContaCellcoin() {
    if(this.reenviandoWebhookContaCellcoin) return;
    this.modalWebhooksContaCellcoin = false;
  }

  selecionouWebhookContaCellcoin() {
    this.carregueWebhooksContaCellcoin();
  }

  carregueWebhooksContaCellcoin() {
    if(!this.webhookContaSelecionado || this.carregandoWebhooksContaCellcoin) return;

    this.carregandoWebhooksContaCellcoin = true;
    this.erroWebhooksContaCellcoin = '';
    this.mensagemWebhooksContaCellcoin = '';
    this.replayWebhooksContaCellcoin = null;

    this.empresaService.listeReplayWebhooksCellcoin(this.webhookContaSelecionado).then((replay: any) => {
      this.replayWebhooksContaCellcoin = replay;
      this.carregandoWebhooksContaCellcoin = false;
    }).catch((erro: any) => {
      this.carregandoWebhooksContaCellcoin = false;
      this.erroWebhooksContaCellcoin = this.extraiaMensagemErro(erro);
    });
  }

  reenvieWebhookContaCellcoin(webhook: any) {
    if(!webhook?.webhookId || this.reenviandoWebhookContaCellcoin) return;

    this.reenviandoWebhookContaCellcoin = webhook.webhookId;
    this.erroWebhooksContaCellcoin = '';
    this.mensagemWebhooksContaCellcoin = '';

    this.empresaService.reenvieReplayWebhookCellcoin(
      this.webhookContaSelecionado,
      webhook.webhookId,
      webhook.filter
    ).then(() => {
      this.reenviandoWebhookContaCellcoin = '';
      this.mensagemWebhooksContaCellcoin = 'Reenvio solicitado para o webhook ' + webhook.webhookId + '.';
    }).catch((erro: any) => {
      this.reenviandoWebhookContaCellcoin = '';
      this.erroWebhooksContaCellcoin = this.extraiaMensagemErro(erro);
    });
  }

  webhooksEnviadosContaCellcoin() {
    return this.replayWebhooksContaCellcoin?.webhooks || [];
  }

  formateJsonWebhookContaCellcoin(valor: any) {
    if(valor == null) return '-';
    if(typeof valor === 'string') return valor;

    try {
      return JSON.stringify(valor, null, 2);
    } catch(erro) {
      return String(valor);
    }
  }

  classeReplayWebhookContaCellcoin(webhook: any) {
    const httpStatus = Number(webhook?.httpStatusCode || 0);
    const status = String(webhook?.status || '').toUpperCase();

    if(httpStatus >= 200 && httpStatus < 300)
      return 'cellcoin-webhook-replay-success';
    if(status === 'PENDENTE' || !httpStatus)
      return 'cellcoin-webhook-replay-warning';
    return 'cellcoin-webhook-replay-error';
  }

  carregueChargebacksCellcoin() {
    if(this.carregandoChargebacksCellcoin) return;

    this.carregandoChargebacksCellcoin = true;
    this.erroChargebacksCellcoin = '';
    this.mensagemChargebacksCellcoin = '';
    this.empresaService.listeChargebacksCellcoin()
      .then((chargebacks: Array<any>) => {
        this.chargebacksCellcoin = chargebacks || [];
        this.chargebacksConsultadosCellcoin = true;
        this.carregandoChargebacksCellcoin = false;
      })
      .catch((erro: any) => {
        this.erroChargebacksCellcoin = this.extraiaMensagemErro(erro);
        this.carregandoChargebacksCellcoin = false;
      });
  }

  importeChargebackCellcoin(chargeback: any) {
    if(this.importandoChargebackCellcoin != null || !chargeback?.podeImportar) return;

    this.importandoChargebackCellcoin = chargeback.galaxPayId;
    this.erroChargebacksCellcoin = '';
    this.mensagemChargebacksCellcoin = '';
    this.empresaService.importeChargebackCellcoin(chargeback.galaxPayId)
      .then((atualizado: any) => {
        const indice = this.chargebacksCellcoin.findIndex((item: any) =>
          String(item.galaxPayId) === String(chargeback.galaxPayId)
        );
        if(indice >= 0)
          this.chargebacksCellcoin[indice] = atualizado;

        this.mensagemChargebacksCellcoin = 'Chargeback importado para o fluxo de disputa do pedido.';
        this.importandoChargebackCellcoin = null;
      })
      .catch((erro: any) => {
        this.erroChargebacksCellcoin = this.extraiaMensagemErro(erro);
        this.importandoChargebackCellcoin = null;
      });
  }

  chargebackCellcoinEmImportacao(chargeback: any) {
    return String(this.importandoChargebackCellcoin) === String(chargeback?.galaxPayId);
  }

  rotuloStatusChargebackCellcoin(status: string) {
    const statusNormalizado = String(status || '').toLowerCase();
    const rotulos: any = {
      awaitingdocumentation: 'Aguardando documentação',
      documentationreceived: 'Documentação recebida',
      underanalysis: 'Em análise',
      inanalysis: 'Em análise',
      won: 'Disputa ganha',
      winsdispute: 'Disputa ganha',
      lost: 'Disputa perdida',
      lostdispute: 'Disputa perdida',
      canceled: 'Cancelado',
      cancelled: 'Cancelado',
      canceleddispute: 'Cancelado'
    };

    return rotulos[statusNormalizado] || status || '-';
  }

  classeStatusChargebackCellcoin(status: string) {
    const statusNormalizado = String(status || '').toLowerCase();
    if(['won', 'winsdispute'].indexOf(statusNormalizado) >= 0)
      return 'cellcoin-chargeback-status-success';
    if(['lost', 'lostdispute', 'canceled', 'cancelled', 'canceleddispute'].indexOf(statusNormalizado) >= 0)
      return 'cellcoin-chargeback-status-danger';
    return 'cellcoin-chargeback-status-warning';
  }

  formateDataChargebackCellcoin(valor: any) {
    return this.formateDataHoraCellcoin(valor);
  }

  desativeContaCellcoin() {
    if(this.executandoAcao) return;

    if(this.contaPodeSerAtivada()){
      this.abraConfirmacaoContaCellcoin(
        'ativar',
        'Ativar conta Cellcoin',
        'A conta será reativada na Cellcoin. Após a confirmação do status ativo, revise as formas de pagamento vinculadas antes de liberar vendas.',
        'Ativar conta'
      );
      return;
    }

    this.abraConfirmacaoContaCellcoin(
      'desativar',
      'Desativar conta Cellcoin',
      'A conta será bloqueada na Cellcoin e poderá ser reativada posteriormente pela API. As formas de pagamento vinculadas podem ficar indisponíveis até a reativação.',
      'Desativar conta'
    );
  }

  encerreContaCellcoin() {
    if(this.executandoAcao) return;

    if(this.saldoDetalhesContaCellcoin() > 0){
      this.erro = 'Para encerrar a conta Cellcoin, zere o saldo primeiro. Saldo atual: ' + this.formateMoedaCellcoin(this.saldoDetalhesContaCellcoin());
      return;
    }

    this.abraConfirmacaoContaCellcoin(
      'encerrar',
      'Encerrar conta Cellcoin',
      'Esta ação não pode ser desfeita. A conta precisa estar sem saldo, sem chaves Pix e sem cobranças pendentes. Após o encerramento, as formas de pagamento vinculadas devem ficar indisponíveis.',
      'Encerrar conta'
    );
  }

  abraConfirmacaoContaCellcoin(acao: string, titulo: string, mensagem: string, textoBotao: string) {
    this.modalConfirmacaoContaCellcoin = {acao, titulo, mensagem, textoBotao, erro: ''};
  }

  fecheConfirmacaoContaCellcoin() {
    if(this.executandoAcao) return;

    this.modalConfirmacaoContaCellcoin = null;
  }

  confirmeAcaoContaCellcoin() {
    if(!this.modalConfirmacaoContaCellcoin || this.executandoAcao) return;

    this.executeAcaoContaCellcoin(this.modalConfirmacaoContaCellcoin.acao);
  }

  acaoContaCellcoinEmExecucao(acao: string) {
    return this.executandoAcao === acao;
  }

  contaPodeSerAtivada() {
    const status = this.statusNormalizadoDetalhesContaCellcoin();
    return ['BLOCKED', 'BLOQUEADO', 'BLOQUEADA', 'DISABLED', 'DESATIVADO', 'DESATIVADA'].indexOf(status) >= 0;
  }

  textoBotaoAtivarDesativarConta() {
    return this.contaPodeSerAtivada() ? 'Ativar conta' : 'Desativar conta';
  }

  bodyDetalhesContaCellcoin() {
    return this.detalhesContaCellcoin?.body || {};
  }

  nomeDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.businessName || body.tradingName || body.fullName || body.socialName || '-';
  }

  iniciaisDetalhesContaCellcoin() {
    return this.iniciaisPessoaCellcoin(this.nomeDetalhesContaCellcoin());
  }

  iniciaisPessoaCellcoin(nome: string) {
    if(!nome || nome === '-') return 'CC';

    const partes = nome.trim().split(/\s+/).filter((parte: string) => !!parte);
    if(!partes.length) return 'CC';
    if(partes.length === 1) return partes[0].substring(0, 2).toUpperCase();

    return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0)).toUpperCase();
  }

  tipoDetalhesContaCellcoin() {
    const tipo = this.detalhesContaCellcoin?.tipo;
    if(tipo) return tipo;

    const documento = String(this.documentoDetalhesContaCellcoin() || '').replace(/\D/g, '');
    if(documento.length === 11) return 'PF';
    if(documento.length === 14) return 'PJ';
    return 'Conta';
  }

  endpointDetalhesContaCellcoin() {
    if(this.detalhesContaCellcoin?.endpoint) return this.detalhesContaCellcoin.endpoint;

    return this.tipoDetalhesContaCellcoin() === 'PJ' ?
      '/baas/v2/account/fetch-business' :
      '/baas/v2/account/fetch';
  }

  clientCodeDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.clientCode || '-';
  }

  emailDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.businessEmail || body.email || body.mail || '-';
  }

  telefoneDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.businessPhoneNumber || body.phoneNumber || body.phone || body.contactNumber || '-';
  }

  dataCriacaoDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return this.formateDataHoraCellcoin(body.createDate || body.createdAt || body.creationDate || this.detalhesContaCellcoin?.createdAt);
  }

  contaDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.businessAccount?.account || body.account?.account || this.detalhesContaCellcoin?.account || '-';
  }

  agenciaDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.businessAccount?.branch || body.account?.branch || this.detalhesContaCellcoin?.branch || '-';
  }

  documentoDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.documentNumber || body.businessDocumentNumber || body.taxId || this.detalhesContaCellcoin?.documentNumber || '-';
  }

  chavePixDetalhesContaCellcoin() {
    return this.detalhesContaCellcoin?.pixKeyEvp || '-';
  }

  saldoDetalhesContaCellcoin() {
    return Number(this.detalhesContaCellcoin?.saldo || 0);
  }

  saldoBloqueadoDetalhesContaCellcoin() {
    return Number(this.bodySaldoDetalhesContaCellcoin().blockedAmount || 0);
  }

  saldoTotalDetalhesContaCellcoin() {
    const body = this.bodySaldoDetalhesContaCellcoin();

    if(body.totalAmount != null)
      return Number(body.totalAmount);

    return this.saldoDetalhesContaCellcoin() + this.saldoBloqueadoDetalhesContaCellcoin();
  }

  possuiDetalhamentoSaldoCellcoin() {
    const body = this.bodySaldoDetalhesContaCellcoin();
    return body.blockedAmount != null || body.totalAmount != null;
  }

  private bodySaldoDetalhesContaCellcoin() {
    return this.detalhesContaCellcoin?.saldoRetorno?.body || {};
  }

  formateMoedaCellcoin(valor: number) {
    return Number(valor || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  statusDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return this.detalhesContaCellcoin?.statusAccount || body.statusAccount || body.status || body.businessAccount?.status || body.account?.status || '-';
  }

  rotuloStatusDetalhesContaCellcoin() {
    const status = this.statusNormalizadoDetalhesContaCellcoin();
    if(['ACTIVE', 'ATIVO', 'APPROVED', 'CONFIRMED', 'RESOURCE_CREATED', 'OPENED', 'ENABLED'].indexOf(status) >= 0)
      return 'Conta ativa';
    if(['BLOCKED', 'BLOQUEADO', 'BLOQUEADA'].indexOf(status) >= 0)
      return 'Conta bloqueada';
    if(['DISABLED', 'DESATIVADO', 'DESATIVADA'].indexOf(status) >= 0)
      return 'Conta desativada';
    if(['CLOSED', 'ENCERRADO', 'ENCERRADA'].indexOf(status) >= 0)
      return 'Conta encerrada';
    if(['ERROR', 'REJECTED', 'REPROVED', 'CANCELED', 'CANCELLED', 'CANCELADO', 'CANCELADA'].indexOf(status) >= 0)
      return 'Atenção';
    return 'Em análise';
  }

  classeStatusDetalhesContaCellcoin() {
    const status = this.statusNormalizadoDetalhesContaCellcoin();
    if(['ACTIVE', 'ATIVO', 'APPROVED', 'CONFIRMED', 'RESOURCE_CREATED', 'OPENED', 'ENABLED'].indexOf(status) >= 0)
      return 'cellcoin-account-badge-success';
    if(['ERROR', 'REJECTED', 'REPROVED', 'BLOCKED', 'BLOQUEADO', 'BLOQUEADA', 'DISABLED', 'DESATIVADO', 'DESATIVADA', 'CLOSED', 'ENCERRADO', 'ENCERRADA', 'CANCELED', 'CANCELLED', 'CANCELADO', 'CANCELADA'].indexOf(status) >= 0)
      return 'cellcoin-account-badge-danger';
    return 'cellcoin-account-badge-warning';
  }

  mensagemStatusDetalhesContaCellcoin() {
    const status = this.statusNormalizadoDetalhesContaCellcoin();
    if(['ACTIVE', 'ATIVO', 'APPROVED', 'CONFIRMED', 'RESOURCE_CREATED', 'OPENED', 'ENABLED'].indexOf(status) >= 0)
      return 'Sem bloqueios retornados';
    if(['BLOCKED', 'BLOQUEADO', 'BLOQUEADA'].indexOf(status) >= 0)
      return 'Conta bloqueada na Cellcoin';
    if(['DISABLED', 'DESATIVADO', 'DESATIVADA'].indexOf(status) >= 0)
      return 'Conta desativada na Cellcoin';
    if(['CLOSED', 'ENCERRADO', 'ENCERRADA'].indexOf(status) >= 0)
      return 'Conta encerrada na Cellcoin';
    if(['ERROR', 'REJECTED', 'REPROVED', 'CANCELED', 'CANCELLED', 'CANCELADO', 'CANCELADA'].indexOf(status) >= 0)
      return 'Verifique a situação da conta';
    return 'Aguardando atualização';
  }

  enderecoDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    return body.businessAddress || body.address || null;
  }

  sociosDetalhesContaCellcoin() {
    const body = this.bodyDetalhesContaCellcoin();
    const socios = body.owners || body.owner || [];
    return Array.isArray(socios) ? socios : [socios];
  }

  private executeAcaoContaCellcoin(acao: string) {
    this.executandoAcao = acao;
    this.erro = '';
    this.mensagem = '';
    if(this.modalConfirmacaoContaCellcoin)
      this.modalConfirmacaoContaCellcoin.erro = '';

    const requisicao = acao === 'encerrar' ?
      this.empresaService.encerreContaCellcoin() :
      acao === 'ativar' ?
        this.empresaService.ativeContaCellcoin() :
        this.empresaService.desativeContaCellcoin();

    requisicao.then((retorno: any) => {
      this.executandoAcao = '';
      this.modalConfirmacaoContaCellcoin = null;
      this.mensagem = acao === 'encerrar' ?
        'Solicitacao de encerramento enviada.' :
        acao === 'ativar' ?
          'Conta ativada na Cellcoin.' :
          'Conta desativada na Cellcoin.';
      if(retorno?.detalhes && !retorno.detalhes.erro)
        this.detalhesContaCellcoin = retorno.detalhes;
      else
        this.carregueDetalhes();
    }).catch((erro: any) => {
      this.executandoAcao = '';
      const mensagemErro = this.extraiaMensagemErro(erro);
      this.erro = mensagemErro;
      if(this.modalConfirmacaoContaCellcoin)
        this.modalConfirmacaoContaCellcoin.erro = mensagemErro;
    });
  }

  private extraiaMensagemErro(erro: any): string {
    if(!erro)
      return 'Falha ao executar ação na conta Cellcoin.';

    if(typeof erro === 'string')
      return erro;

    return erro.message || erro.erro || erro.error?.message || JSON.stringify(erro);
  }

  private statusNormalizadoDetalhesContaCellcoin() {
    return String(this.statusDetalhesContaCellcoin() || '').toUpperCase();
  }

  private formateDataHoraCellcoin(valor: any) {
    if(!valor) return '-';

    const data = new Date(valor);
    if(isNaN(data.getTime())) return valor;

    return data.toLocaleString('pt-BR');
  }

  private inicializePeriodoExtratoCellcoin() {
    const fim = new Date();
    const inicio = new Date(fim.getFullYear(), fim.getMonth(), fim.getDate() - 6);
    this.dataInicialExtratoCellcoin = this.formateDataInputCellcoin(inicio);
    this.dataFinalExtratoCellcoin = this.formateDataInputCellcoin(fim);
    this.dataInicialConsolidadoCellcoin = this.dataInicialExtratoCellcoin;
    this.dataFinalConsolidadoCellcoin = this.dataFinalExtratoCellcoin;
    this.dataInicialCobrancasCellcoin = this.dataInicialExtratoCellcoin;
    this.dataFinalCobrancasCellcoin = this.dataFinalExtratoCellcoin;
    this.dataInicialRecebiveisCellcoin = this.formateDataInputCellcoin(fim);
    const fimRecebiveis = new Date(fim.getFullYear(), fim.getMonth(), fim.getDate() + 29);
    this.dataFinalRecebiveisCellcoin = this.formateDataInputCellcoin(fimRecebiveis);
  }

  private formateDataInputCellcoin(data: Date) {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  private validePeriodoExtratoCellcoin() {
    return this.validePeriodoCellcoin(
      this.dataInicialExtratoCellcoin,
      this.dataFinalExtratoCellcoin,
      'extrato'
    );
  }

  private validePeriodoCellcoin(dataInicial: string, dataFinal: string, tipo: string, limiteDias: number = 7) {
    if(!dataInicial || !dataFinal)
      return `Informe as datas inicial e final do ${tipo}.`;

    const inicio = new Date(`${dataInicial}T00:00:00`);
    const fim = new Date(`${dataFinal}T23:59:59`);
    if(inicio.getTime() > fim.getTime())
      return 'A data inicial não pode ser posterior à data final.';
    if(fim.getTime() - inicio.getTime() > limiteDias * 24 * 60 * 60 * 1000)
      return `O período consultado não pode ultrapassar ${limiteDias} dias.`;

    return '';
  }
}
